module.exports = __webpack_public_path__ + "static/media/Mano 3.e0aa7e54.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/Mano 3.png
// module id = 185
// module chunks = 0